require('./verifyOtpStep.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ utils
const { formatText, FormattedText } = require('core/i18n').i18n;

//@components
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');

class VerifyOtpStep extends React.Component {
    buildReadOnly() {
        return  (
            <div className="verify-otp-step__security-pattern-message-column">
                <p className="verify-otp-step__security-pattern-message-block">
                    <FormattedText
                        className="verify-otp-step__security-pattern-message"
                        value="verifyOtpStep-securityPatternMessage"
                    />
                </p>
            </div>
        );
    }

    buildInlineErrorMessage() {
        const { invalidSecurityData } = this.props;

        if (invalidSecurityData) {
            return (
                <div className="verify-otp-step__input-error-section">
                    <p className="verify-otp-step__invalid-input-message">
                        <FormattedText value="verifyOtpStep-invalidInputMessage" />
                    </p>
                    <p className="verify-otp-step__try-again-message">
                        <FormattedText value="verifyOtpStep-retryInputMessage" />
                    </p>
                </div>
            );
        }

        return null;
    }

    buildSecurityPattern() {
        const { 
            operationType, 
            operationParams, 
            printTitleValue, 
            withValidateButton,
            pdfToShow,
            isPdfToShowBase64,
            pdfToShowFetching,
            pdfToShowError
        } = this.props;
        return  (
            <div className="verify-otp-step__security-pattern-column">
                <div className="signature-pattern-wrapper">
                    <SignaturePattern
                        operationType={operationType}
                        operationParams={operationParams}
                        isInVerticalWizard
                        printTitleValue={(printTitleValue ? printTitleValue : undefined )}
                        withValidateButton={withValidateButton}
                        pdfToShow={pdfToShow}
                        isPdfToShowBase64={isPdfToShowBase64}
                        pdfToShowFetching={pdfToShowFetching}
                        pdfToShowError={pdfToShowError}
                    />
                    {this.buildInlineErrorMessage()}
                </div>
            </div>
        );
    }

    buildOTPComponent() {
        const { isShowOnly } = this.props;
        return (isShowOnly) ? this.buildReadOnly() : this.buildSecurityPattern();
    }

    render() {
        const otpComponent = this.buildOTPComponent();
        const title = formatText('verifyOtpStep-title');
        const subTitle = formatText('verifyOtpStep-subTitle');

        return (
            <section className="step-container">
                <div className="verify-otp-step">
                    <div className="container-keyscc__header">
                        <h4 className="wizard-step--vertical__title">
                            {title}
                        </h4>
                    </div>
                    <div className="wizard-step--vertical__sub-title">
                        {subTitle}
                    </div>
                    <section className="verify-otp-step__otp-section">
                        <div className="verify-otp-step__row">
                            {otpComponent}
                        </div>
                    </section>
                </div>
            </section>
        );
    }
}

VerifyOtpStep.propTypes = {
    operationType: PropTypes.number.isRequired,
    operationParams: PropTypes.object.isRequired,
    isShowOnly: PropTypes.bool,
    invalidSecurityData: PropTypes.bool,
    printTitleValue: PropTypes.string,
    withValidateButton: PropTypes.bool,
    pdfToShow: PropTypes.string,
    isPdfToShowBase64: PropTypes.bool,
    pdfToShowFetching: PropTypes.bool,
    pdfToShowError: PropTypes.bool,
};

VerifyOtpStep.defaultProps = {
    invalidSecurityData: false,
    withValidateButton: !__CONTACT_CENTER__,
    pdfToShow: null,
    isPdfToShowBase64: true,
    pdfToShowFetching: false,
    pdfToShowError: false,
};

module.exports = VerifyOtpStep;
